import * as React from 'react'
import { styled } from 'next-yak'

import * as glyphs from '../../../../icons/glyphs'
import * as styles from '../../../../styles'

import { Tag } from '../../../tag/Tag'

export function HiddenTag({ children }: { children: React.ReactNode }) {
  return <styles.card.reward.MemberTag color="green">{children}</styles.card.reward.MemberTag>
}

export function FeaturedTag({ children }: { children: React.ReactNode }) {
  return (
    <styles.card.reward.MemberTag color="blue">
      <glyphs.fill.Star size={12} />
      <CenterText>{children}</CenterText>
    </styles.card.reward.MemberTag>
  )
}

export function DeliveryDateTag({ children }: { children: React.ReactNode }) {
  return (
    <Tag color="sand">
      <glyphs.stroke.Calendar size={12} />
      {children}
    </Tag>
  )
}

export function StockTag({ children }: { children: React.ReactNode }) {
  return (
    <Tag color="blue">
      <glyphs.fill.Heart size={12} />
      {children}
    </Tag>
  )
}

const CenterText = styled.div`
  position: relative;
  top: -1px;
`
